import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ChatButton from './ChatButton';
import ParticipantsNotification from './ParticipantsNotification';

export default function Layout() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <ParticipantsNotification />
      <main>
        <Outlet />
      </main>
      <ChatButton />
      <Footer />
    </div>
  );
}